import React, { useEffect, useState } from "react";

function Movie() {
  const [movies, setMovies] = useState([]);

  useEffect(() => {
    fetch(
      "https://cors-anywhere.herokuapp.com/https://api.themoviedb.org/3/discover/movie?sort_by=popularity.desc&api_key=04c35731a5ee918f014970082a0088b1&page=1"
    )
      .then((response) => response.json())
      .then((data) => {
        setMovies(data.results);
        console.log(data.results);
      });
  }, []);

  return (
    <div>
      {movies.map(({ title, poster_path, overview, vote_average, id }) => {
        const imageUrl = `https://image.tmdb.org/t/p/w1280/${poster_path}`;

        const setRating = (vote) => {
          if (vote >= 8) {
            return "bg-success";
          } else if (vote >= 6) {
            return "bg-warning";
          } else {
            return "bg-danger";
          }
        };

        return (
          <div key={id}>
            <div className="card">
              <img
                className="rounded-right"
                src={imageUrl}
                width="320px"
                height="320px"
                alt={title}
              />
              <div className="card-body">
                <h5 className="card-title">{title}</h5>
                <p className="card-text">{overview}</p>
                <p className="card-text">
                  <small className="text-muted">
                    Rating:{" "}
                    <span
                      style={{ color: "#000000" }}
                      className={`p-1 rounded ${setRating(vote_average)}`}
                    >
                      {vote_average}
                    </span>
                  </small>
                </p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default Movie;
